import { useEffect } from 'react';
import seoEntriesData from './seo.json';

export type SeoKey =
  | 'home'
  | 'about'
  | 'careers'
  | 'cooperation'
  | 'franchise'
  | 'news'
  | 'newsArticleDouyinBaike6'
  | 'twinkleColor'
  | 'pocketKit';

export type SeoEntry = {
  title: string;
  description: string;
  keywords: string;
};

export const seoEntries = seoEntriesData as Record<SeoKey, SeoEntry>;

export function useSeo(seoKey: SeoKey) {
  useEffect(() => {
    const nextSeo = seoEntries[seoKey];
    const metaDescription = document.querySelector<HTMLMetaElement>('meta[name="description"]');
    const metaKeywords = document.querySelector<HTMLMetaElement>('meta[name="keywords"]');
    const previousTitle = document.title;
    const previousDescription = metaDescription?.getAttribute('content');
    const previousKeywords = metaKeywords?.getAttribute('content');

    document.title = nextSeo.title;

    if (metaDescription) {
      metaDescription.setAttribute('content', nextSeo.description);
    }

    if (metaKeywords) {
      metaKeywords.setAttribute('content', nextSeo.keywords);
    }

    return () => {
      document.title = previousTitle;

      if (metaDescription) {
        if (previousDescription) {
          metaDescription.setAttribute('content', previousDescription);
        } else {
          metaDescription.removeAttribute('content');
        }
      }

      if (metaKeywords) {
        if (previousKeywords) {
          metaKeywords.setAttribute('content', previousKeywords);
        } else {
          metaKeywords.removeAttribute('content');
        }
      }
    };
  }, [seoKey]);
}
